import styled from "styled-components";

export const StyledHeader = styled.header`
	position: fixed;
	top: 0;
	left: 0;

	width: 100%;

	background: ${(p) => p.theme.colors.white};
	z-index: 99;

	box-shadow: ${({ scroll, shadow }) => (scroll >= 80 ? shadow : null)};
`;

/* -------------------------------- контакты -------------------------------- */

export const StyledListContacts = styled.ul`
	@media (max-width: 420px) {
		display: none;
	}
`;

export const StyledItemContact = styled.li`
	font-size: ${(p) => p.theme.fontSizes.fs15};
	transition: 0.3s ease;
	cursor: pointer;

	margin: ${({ margin }) => margin || "0"};

	& span {
		margin-right: 5px;
	}

	&:hover {
		color: ${(p) => p.theme.colors.hoverText};
	}
	@media (max-width: 420px) {
		margin: ${({ mobileMargin }) => mobileMargin || "0"};
		margin-bottom: 5px;
		font-size: ${(p) => p.theme.fontSizes.fs20};
	}
`;

export const DropMenuWrapper = styled.div`
	@media (min-width: 421px) {
		display: none;
	}
`;
